(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3880],{

/***/ 79941:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/franchise-enquiry",
      function () {
        return __webpack_require__(88871);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/banner-s.6331e691.jpg","height":2800,"width":5352,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAbEAACAwADAAAAAAAAAAAAAAACBAABAxESgf/EABQBAQAAAAAAAAAAAAAAAAAAAAT/xAAWEQADAAAAAAAAAAAAAAAAAAAAAjH/2gAMAwEAAhEDEQA/AIazjDbOK2mxiGpWBdCsb48iIh3ohIf/2Q=="});

/***/ }),

/***/ 62511:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/icon-adv.015d447b.jpg","height":307,"width":343,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAHAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAeEAABBAMAAwAAAAAAAAAAAAACAAEDEQQFISIxkf/EABUBAQEAAAAAAAAAAAAAAAAAAAID/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAECEhP/2gAMAwEAAhEDEQA/AKZPrNnJnm4bCWPHM2NnE+j68aqq5X1ERGqKaSP/2Q=="});

/***/ }),

/***/ 50205:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s11.1ce8e384.png","height":269,"width":317,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAIVBMVEX////8+/rq39jl1M7y4+H48e/y6+bQtp7mf4TFhofO1M/ZMBTaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMklEQVR4nB2KQQ4AIAzCGBub+v8Hi/ZAaFIAYWCozKD9RBFHqJ1ND3pVU4uvmvkxQvK5EwwAoh6KyboAAAAASUVORK5CYII="});

/***/ }),

/***/ 56742:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s12.5c4b9938.png","height":389,"width":373,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEX////8+/q5kmrSycG6mnbp6Obl4t/NT0rd1c3GtKTGs6L7+PV9SXnSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMUlEQVR4nFXKQQ4AIAgDQShUUP//X3syYU/TpGY/LkUhUh0XUIWJBLCFDrJDZ9fwaw8abADGejF5rwAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 45624:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s13.2ab4d420.png","height":373,"width":285,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAJFBMVEX+//7iKjjw7un39fPbrqnn4Nrd0snSwrfrzcvLW1naTFPMRUZ0WdnIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALUlEQVR4nCWKRwIAIAyDknQ5/v9ftXIEgI+lIgxRWQlok/NaJ8eLXP249ysBBw77AHsfOPDLAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 10631:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s14.b6cba245.png","height":413,"width":441,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAG1BMVEX////6+ff08e7s5+TFrqLl39vGvrjd1tDmyL+lTdhyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAL0lEQVR4nB2JSRIAMAjCWNT2/y+ulEsyBABkZCRFrthrnaA+UtqtOqFnavgP9/IBC3AAdiIVhckAAAAASUVORK5CYII="});

/***/ }),

/***/ 66202:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s2.03af46af.png","height":329,"width":305,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAOVBMVEX////8+/rv6ujdxLb08e/sMT+wubbo4d+5k2vJysby7urHw7zJkpLEgYK+pIrv5t7o2s7LeX/02tk+sYoAAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANElEQVR4nB2HxxEAIAzD7IQWOuw/LEf0kQSAQnx0qscq27+WZgJC40gZwXo83637M8hdlQ8dawE1P6cWOAAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 30516:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s3.65039ea4.png","height":345,"width":333,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEX////k2M+/l43Nysnr4d78+/r28/DHv7nCsqLIuKm8rZ+N7ICKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANUlEQVR4nB3JyQ3AMAwDwZWoy+6/4MiZzxIgECshw5cl1TqjLrCe28YKaZ9H+pPHfeoNW8UHHk8AxQU33/gAAAAASUVORK5CYII="});

/***/ }),

/***/ 81806:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s4.caa05980.png","height":329,"width":245,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAANlBMVEX////z7+7HwL7m4N339vT7+PfMysn05+XAUk7My8vtk5jja3LgXWXgNkHX09Dv2tjCYmDARUI1zorPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANElEQVR4nA3JNwIAIAjAwAAq9vL/z0qWDAekRGStGEi5VQVp9cXYqjtszDHDVu/LyeZy8gcYPgEOc/YoqAAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 71380:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s5.8a3afbb9.png","height":289,"width":373,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAHlBMVEX+/v7e1dH28u/69/bby7u1iVzWv6fp5eHIwLeyn5ChRv2/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAALElEQVR4nB2KQRIAIAiEWFez/v/hMk4MA4CDISQxam31b6uOnjhXVapnzTRcCSYAbTegMCIAAAAASUVORK5CYII="});

/***/ }),

/***/ 77787:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s6.f883ab39.png","height":305,"width":268,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAHlBMVEX+/f3s6uTo49zk2tP38/Hmi4/js7DyByDkfIHjdHqcX3PVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMElEQVR4nBWKhwkAMBACbWn7LxwfRcETAJQGqKrtvbaDcJ3HDvI1B5dLiD1GD2LwAQ+4AIaqSYICAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 10906:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s7.7426d27c.png","height":433,"width":397,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAJFBMVEX////u6uX29PLp5N77+vnErpq9kIXk29TNeHTSn5nitbG+VFBfO5TuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAM0lEQVR4nBWKCwrAUAzCYm3fZ7v/fecQEwQBXAHVCfQOpL9SFc+6VOZ5j8f5ybMmbm83Hw+gAJami1LzAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 32223:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s8.ad2f13ec.png","height":369,"width":393,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEX////Jwry6mom5pZvh3tv7+/rSyMP29PPf18/GuLLw7Om/hoCkiXDs6+m5c29Tt9XkAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANklEQVR4nD2JxxEAMAzCwC1O3X/clEf0QZyASzF/i1jz3WAtcO2qpMNFyMhTjFVHHGlGkcRnAx6gAMvKghD2AAAAAElFTkSuQmCC"});

/***/ }),

/***/ 98047:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s9.21a87a68.png","height":453,"width":301,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAAIVBMVEX////q2dP26ej38O7px8T8+fjXoJfSlImxUTbhfIDw09Lv5eRBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVR4nB3KuQEAIAzDQOUhAfYfGIfm5MKALSByKHdX7VzIntnbZH1DzwcI7wBm5iawsgAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 43115:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/skv.15117077.png","height":701,"width":1000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAY1BMVEVHcEyhTEgkFRONZ1Z/dGlvFhq1Xl9ZOUu4Ji+4WVuUZFPdkITXgHl2VT6TcV25d3CzcGqQaFqgc1zCkWx+RzexPT2GOztDESZGCipbKjHdWVe7e2yHXl+pemBjFBWCKCV2RkVNT6mwAAAAGnRSTlMA9hV2Tvv+Lvrjl/v1zeC0yvU9e4X8+3q4yNjHizMAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA5SURBVHicBcEFAoAgAACxozFRMAHj/69kA4fWUgKzCks/gVu7cRBP5Ko2Z/El7mpLOV7F+Xu/G7M1NWgChg38cJYAAAAASUVORK5CYII="});

/***/ }),

/***/ 88871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ franchise_enquiry; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/layout/layout.tsx + 22 modules
var layout = __webpack_require__(16559);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/assets/images/adv-header.jpg
/* harmony default export */ var adv_header = ({"src":"/_next/static/media/adv-header.c81cb327.jpg","height":457,"width":3930,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAABAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAXEAEBAQEAAAAAAAAAAAAAAAAAAjSB/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/xAAWEQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhEDEQA/AK3Ou+ACL2//2Q=="});
// EXTERNAL MODULE: ./src/assets/images/icon-adv.jpg
var icon_adv = __webpack_require__(62511);
// EXTERNAL MODULE: ./src/assets/images/skv.png
var skv = __webpack_require__(43115);
// EXTERNAL MODULE: ./src/assets/images/s2.png
var s2 = __webpack_require__(66202);
// EXTERNAL MODULE: ./src/assets/images/s3.png
var s3 = __webpack_require__(30516);
// EXTERNAL MODULE: ./src/assets/images/s4.png
var s4 = __webpack_require__(81806);
// EXTERNAL MODULE: ./src/assets/images/s5.png
var s5 = __webpack_require__(71380);
// EXTERNAL MODULE: ./src/assets/images/s6.png
var s6 = __webpack_require__(77787);
// EXTERNAL MODULE: ./src/assets/images/s7.png
var s7 = __webpack_require__(10906);
// EXTERNAL MODULE: ./src/assets/images/s8.png
var s8 = __webpack_require__(32223);
// EXTERNAL MODULE: ./src/assets/images/s9.png
var s9 = __webpack_require__(98047);
// EXTERNAL MODULE: ./src/assets/images/s11.png
var s11 = __webpack_require__(50205);
// EXTERNAL MODULE: ./src/assets/images/s12.png
var s12 = __webpack_require__(56742);
// EXTERNAL MODULE: ./src/assets/images/s13.png
var s13 = __webpack_require__(45624);
// EXTERNAL MODULE: ./src/assets/images/s14.png
var s14 = __webpack_require__(10631);
// EXTERNAL MODULE: ./src/styles/franchise.module.scss
var franchise_module = __webpack_require__(76703);
var franchise_module_default = /*#__PURE__*/__webpack_require__.n(franchise_module);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./src/utils/regex.ts
var regex = __webpack_require__(1233);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
;// CONCATENATED MODULE: ./src/pages/franchise-enquiry.tsx































var OTP_RESEND_COOLDOWN = 60; // seconds
var VerifiedBadge = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: (franchise_module_default()).verified_badge,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                })
            }),
            "Verified"
        ]
    });
};
var Franchise = function() {
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(true), showfrom = ref1[0], setshowfrom = ref1[1];
    var ref2 = (0,react.useState)([
        "PAN",
        "Aadhaar",
        "Passport"
    ]), idType = ref2[0];
    var ref3 = (0,react.useState)([]), state = ref3[0], setState = ref3[1];
    // ── OTP state ──────────────────────────────────────
    var ref4 = (0,react.useState)(null), mobileOtpUuid = ref4[0], setMobileOtpUuid = ref4[1];
    var ref5 = (0,react.useState)(null), emailOtpUuid = ref5[0], setEmailOtpUuid = ref5[1];
    var ref6 = (0,react.useState)(false), mobileVerified = ref6[0], setMobileVerified = ref6[1];
    var ref7 = (0,react.useState)(false), emailVerified = ref7[0], setEmailVerified = ref7[1];
    var ref8 = (0,react.useState)(""), mobileOtp = ref8[0], setMobileOtp = ref8[1];
    var ref9 = (0,react.useState)(""), emailOtp = ref9[0], setEmailOtp = ref9[1];
    var ref10 = (0,react.useState)(null), mobileOtpError = ref10[0], setMobileOtpError = ref10[1];
    var ref11 = (0,react.useState)(null), emailOtpError = ref11[0], setEmailOtpError = ref11[1];
    var ref12 = (0,react.useState)(false), mobileOtpLoading = ref12[0], setMobileOtpLoading = ref12[1];
    var ref13 = (0,react.useState)(false), emailOtpLoading = ref13[0], setEmailOtpLoading = ref13[1];
    var ref14 = (0,react.useState)(0), mobileResendTimer = ref14[0], setMobileResendTimer = ref14[1];
    var ref15 = (0,react.useState)(0), emailResendTimer = ref15[0], setEmailResendTimer = ref15[1];
    var ref16 = (0,react.useState)(""), verifiedMobileValue = ref16[0], setVerifiedMobileValue = ref16[1];
    var ref17 = (0,react.useState)(""), verifiedEmailValue = ref17[0], setVerifiedEmailValue = ref17[1];
    var ref18 = (0,react.useState)(""), otpSentMobileValue = ref18[0], setOtpSentMobileValue = ref18[1];
    var ref19 = (0,react.useState)(""), otpSentEmailValue = ref19[0], setOtpSentEmailValue = ref19[1];
    var mobileTimerRef = (0,react.useRef)(null);
    var emailTimerRef = (0,react.useRef)(null);
    // ── Cooldown timer helpers ─────────────────────────
    var startMobileTimer = (0,react.useCallback)(function() {
        setMobileResendTimer(OTP_RESEND_COOLDOWN);
        if (mobileTimerRef.current) clearInterval(mobileTimerRef.current);
        mobileTimerRef.current = setInterval(function() {
            setMobileResendTimer(function(prev) {
                if (prev <= 1) {
                    if (mobileTimerRef.current) clearInterval(mobileTimerRef.current);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    }, []);
    var startEmailTimer = (0,react.useCallback)(function() {
        setEmailResendTimer(OTP_RESEND_COOLDOWN);
        if (emailTimerRef.current) clearInterval(emailTimerRef.current);
        emailTimerRef.current = setInterval(function() {
            setEmailResendTimer(function(prev) {
                if (prev <= 1) {
                    if (emailTimerRef.current) clearInterval(emailTimerRef.current);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    }, []);
    // Cleanup timers on unmount
    (0,react.useEffect)(function() {
        return function() {
            if (mobileTimerRef.current) clearInterval(mobileTimerRef.current);
            if (emailTimerRef.current) clearInterval(emailTimerRef.current);
        };
    }, []);
    // ── OTP handlers ───────────────────────────────────
    var handleSendMobileOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(mobile) {
            var data, ref, ref1, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(mobile.length !== 10)) {
                            _ctx.next = 3;
                            break;
                        }
                        setMobileOtpError("Please enter a valid 10-digit mobile number.");
                        return _ctx.abrupt("return");
                    case 3:
                        setMobileOtpLoading(true);
                        setMobileOtpError(null);
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return http_client/* default.post */.Z.post(endpoints/* default.franchiseOtp.sendMobileOtp */.Z.franchiseOtp.sendMobileOtp(), {
                            mobile: mobile
                        });
                    case 8:
                        data = _ctx.sent.data;
                        if (data.status) {
                            setMobileOtpUuid(data.otp_uuid);
                            setOtpSentMobileValue(mobile);
                            setMobileOtp("");
                            startMobileTimer();
                            (0,react_toastify_esm/* toast */.Am)("OTP sent to your mobile!", {
                                type: "success",
                                toastId: "mob-otp-sent"
                            });
                        } else {
                            setMobileOtpError((data === null || data === void 0 ? void 0 : data.message) || "Failed to send OTP. Please try again.");
                        }
                        _ctx.next = 17;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](5);
                        ;
                        error = _ctx.t0;
                        setMobileOtpError((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || "Failed to send OTP. Please try again.");
                    case 17:
                        setMobileOtpLoading(false);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    12
                ]
            ]);
        }));
        return function handleSendMobileOtp(mobile) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleVerifyMobileOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(mobile) {
            var data, ref, ref1, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!mobileOtp || mobileOtp.length < 4)) {
                            _ctx.next = 3;
                            break;
                        }
                        setMobileOtpError("Please enter the OTP.");
                        return _ctx.abrupt("return");
                    case 3:
                        setMobileOtpLoading(true);
                        setMobileOtpError(null);
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return http_client/* default.post */.Z.post(endpoints/* default.franchiseOtp.verifyMobileOtp */.Z.franchiseOtp.verifyMobileOtp(), {
                            mobile: mobile,
                            otp: mobileOtp,
                            otp_uuid: mobileOtpUuid
                        });
                    case 8:
                        data = _ctx.sent.data;
                        if (data.status) {
                            setMobileVerified(true);
                            setVerifiedMobileValue(mobile);
                            (0,react_toastify_esm/* toast */.Am)("Mobile verified successfully!", {
                                type: "success",
                                toastId: "mob-verified"
                            });
                        } else {
                            setMobileOtpError((data === null || data === void 0 ? void 0 : data.message) || "Invalid or expired OTP.");
                        }
                        _ctx.next = 17;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](5);
                        ;
                        error = _ctx.t0;
                        setMobileOtpError((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || "Invalid or expired OTP.");
                    case 17:
                        setMobileOtpLoading(false);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    12
                ]
            ]);
        }));
        return function handleVerifyMobileOtp(mobile) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSendEmailOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(email) {
            var data, ref, ref1, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))) {
                            _ctx.next = 3;
                            break;
                        }
                        setEmailOtpError("Please enter a valid email address.");
                        return _ctx.abrupt("return");
                    case 3:
                        setEmailOtpLoading(true);
                        setEmailOtpError(null);
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return http_client/* default.post */.Z.post(endpoints/* default.franchiseOtp.sendEmailOtp */.Z.franchiseOtp.sendEmailOtp(), {
                            email: email
                        });
                    case 8:
                        data = _ctx.sent.data;
                        if (data.status) {
                            setEmailOtpUuid(data.otp_uuid);
                            setOtpSentEmailValue(email);
                            setEmailOtp("");
                            startEmailTimer();
                            (0,react_toastify_esm/* toast */.Am)("OTP sent to your email!", {
                                type: "success",
                                toastId: "email-otp-sent"
                            });
                        } else {
                            setEmailOtpError((data === null || data === void 0 ? void 0 : data.message) || "Failed to send OTP. Please try again.");
                        }
                        _ctx.next = 17;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](5);
                        ;
                        error = _ctx.t0;
                        setEmailOtpError((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || "Failed to send OTP. Please try again.");
                    case 17:
                        setEmailOtpLoading(false);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    12
                ]
            ]);
        }));
        return function handleSendEmailOtp(email) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleVerifyEmailOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(email) {
            var data, ref, ref1, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!emailOtp || emailOtp.length < 4)) {
                            _ctx.next = 3;
                            break;
                        }
                        setEmailOtpError("Please enter the OTP.");
                        return _ctx.abrupt("return");
                    case 3:
                        setEmailOtpLoading(true);
                        setEmailOtpError(null);
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return http_client/* default.post */.Z.post(endpoints/* default.franchiseOtp.verifyEmailOtp */.Z.franchiseOtp.verifyEmailOtp(), {
                            email: email,
                            otp: emailOtp,
                            otp_uuid: emailOtpUuid
                        });
                    case 8:
                        data = _ctx.sent.data;
                        if (data.status) {
                            setEmailVerified(true);
                            setVerifiedEmailValue(email);
                            (0,react_toastify_esm/* toast */.Am)("Email verified successfully!", {
                                type: "success",
                                toastId: "email-verified"
                            });
                        } else {
                            setEmailOtpError((data === null || data === void 0 ? void 0 : data.message) || "Invalid or expired OTP.");
                        }
                        _ctx.next = 17;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](5);
                        ;
                        error = _ctx.t0;
                        setEmailOtpError((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || "Invalid or expired OTP.");
                    case 17:
                        setEmailOtpLoading(false);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    12
                ]
            ]);
        }));
        return function handleVerifyEmailOtp(email) {
            return _ref.apply(this, arguments);
        };
    }();
    // ── Formik setup ───────────────────────────────────
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            name: "",
            mobile: "",
            email: "",
            location: "",
            state: "",
            present_address: "",
            id_number: "",
            id_type: "",
            current_business: "",
            turnover: "",
            capacity: "",
            mode: ""
        },
        validationSchema: es/* object */.Ry({
            name: es/* string */.Z_().required("Name is required"),
            mobile: es/* string */.Z_().matches(regex/* phoneRegExp */.O, "Mobile number is not valid").test("len", "Mobile number needs to be exactly 10 digits", function(val) {
                return (val === null || val === void 0 ? void 0 : val.toString().length) === 10;
            }).required("Required"),
            email: es/* string */.Z_().email("Invalid email format").required(" Email is Required"),
            location: es/* string */.Z_().required("Preferred Location is required"),
            state: es/* string */.Z_().required("State is required"),
            present_address: es/* string */.Z_().required("Present Address is required"),
            current_business: es/* string */.Z_().required("Nature of Current Business is required"),
            id_number: es/* string */.Z_().required("Id Number is required"),
            id_type: es/* string */.Z_().required("Id Type is required"),
            turnover: es/* string */.Z_().required("Yearly Turnover is required"),
            capacity: es/* string */.Z_().required("Investment Capacity is required"),
            mode: es/* string */.Z_().required("Mode of Investment is required")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                var data, ref, ref1, err;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(!mobileVerified || !emailVerified)) {
                                _ctx.next = 3;
                                break;
                            }
                            (0,react_toastify_esm/* toast */.Am)("Please verify your mobile number and email before submitting.", {
                                type: "error",
                                toastId: "otp-guard"
                            });
                            return _ctx.abrupt("return");
                        case 3:
                            setLoading(true);
                            _ctx.prev = 4;
                            _ctx.next = 7;
                            return http_client/* default.post */.Z.post(endpoints/* default.franchiseEnquiry */.Z.franchiseEnquiry(), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                                mobile_otp_uuid: mobileOtpUuid,
                                email_otp_uuid: emailOtpUuid
                            }), {
                                headers: {
                                    Accept: "application/json"
                                }
                            });
                        case 7:
                            data = _ctx.sent.data;
                            if (data.status) {
                                setshowfrom(false);
                            } else {
                                (0,react_toastify_esm/* toast */.Am)((data === null || data === void 0 ? void 0 : data.message) || "Submission failed. Please try again.", {
                                    type: "error",
                                    toastId: "condition-err"
                                });
                            }
                            _ctx.next = 16;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](4);
                            ;
                            err = _ctx.t0;
                            (0,react_toastify_esm/* toast */.Am)((err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || "Something went wrong. Please try again.", {
                                type: "error",
                                toastId: "submit-err"
                            });
                        case 16:
                            setLoading(false);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        11
                    ]
                ]);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    // ── Tamper detection: reset verification if values change ──
    (0,react.useEffect)(function() {
        if (mobileOtpUuid && formik.values.mobile !== otpSentMobileValue) {
            setMobileVerified(false);
            setMobileOtpUuid(null);
            setMobileOtp("");
            setMobileOtpError(null);
            setMobileResendTimer(0);
            if (mobileTimerRef.current) clearInterval(mobileTimerRef.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formik.values.mobile
    ]);
    (0,react.useEffect)(function() {
        if (emailOtpUuid && formik.values.email !== otpSentEmailValue) {
            setEmailVerified(false);
            setEmailOtpUuid(null);
            setEmailOtp("");
            setEmailOtpError(null);
            setEmailResendTimer(0);
            if (emailTimerRef.current) clearInterval(emailTimerRef.current);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formik.values.email
    ]);
    // ── Load states ────────────────────────────────────
    var stateLoad = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(country) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return http_client/* default.get */.Z.get(endpoints/* default.state */.Z.state(country));
                    case 2:
                        data = _ctx.sent.data;
                        setState(data.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function stateLoad(country) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        stateLoad("IND");
    }, []);
    // ── Derived flags ──────────────────────────────────
    var canSubmit = mobileVerified && emailVerified && !loading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (franchise_module_default()).franchise_banner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: __webpack_require__(69430),
                    className: "img-fluid",
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (franchise_module_default()).franchise_main,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row justify-content-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-md-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Inviting Franchise Partners"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Come, become a part of the Senco family- to the world of design and karigari and a part of one of the most trusted brands in the country. With our origins in Calcutta, the land of Art, Culture and Craftsmanship, and a legacy of more than 85+ years, with 200+ stores across the country, be a partner, and the chosen one for carrying the legacy in your geography."
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (franchise_module_default()).franchise_form,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row justify-content-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (franchise_module_default()).text_head,
                                    children: "To be part of the amazing world of designs and karigari, kindly fill in your personal & business information which is essential for further processing of your application."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (franchise_module_default()).franchise_form_main,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                                        children: showfrom ? /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                            onSubmit: formik.handleSubmit,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "row",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-md-12",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                children: "Personal Details"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "row ",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "col-md-3",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "mb-3",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                    type: "text",
                                                                                    className: "form-control",
                                                                                    placeholder: "Name"
                                                                                }, formik.getFieldProps("name"))),
                                                                                formik.touched.name && formik.errors.name ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    className: "text-danger",
                                                                                    children: formik.errors.name
                                                                                }) : null
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "col-md-4",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "mb-3",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (franchise_module_default()).inline_input_wrapper,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                            type: "text",
                                                                                            className: "form-control",
                                                                                            placeholder: "Mobile Number",
                                                                                            maxLength: 10
                                                                                        }, formik.getFieldProps("mobile"))),
                                                                                        mobileVerified ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (franchise_module_default()).inline_badge,
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifiedBadge, {})
                                                                                        }) : formik.values.mobile.length === 10 && /^\d{10}$/.test(formik.values.mobile) && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                            type: "button",
                                                                                            className: (franchise_module_default()).inline_action_btn,
                                                                                            disabled: mobileOtpLoading || mobileResendTimer > 0,
                                                                                            onClick: function() {
                                                                                                return handleSendMobileOtp(formik.values.mobile);
                                                                                            },
                                                                                            children: mobileOtpLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                                                                animation: "border",
                                                                                                size: "sm"
                                                                                            }) : mobileResendTimer > 0 ? "Resend (".concat(mobileResendTimer, "s)") : "Send OTP"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                formik.touched.mobile && formik.errors.mobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    className: "text-danger",
                                                                                    children: formik.errors.mobile
                                                                                }) : null,
                                                                                mobileOtpUuid && !mobileVerified && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: (franchise_module_default()).otp_field_group,
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                                    type: "text",
                                                                                                    className: "form-control ".concat((franchise_module_default()).otp_input),
                                                                                                    placeholder: "Enter OTP",
                                                                                                    maxLength: 6,
                                                                                                    value: mobileOtp,
                                                                                                    onChange: function(e) {
                                                                                                        setMobileOtp(e.target.value.replace(/\D/g, ""));
                                                                                                        setMobileOtpError(null);
                                                                                                    }
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                                    type: "button",
                                                                                                    className: (franchise_module_default()).verify_btn,
                                                                                                    disabled: mobileOtpLoading || mobileOtp.length < 4,
                                                                                                    onClick: function() {
                                                                                                        return handleVerifyMobileOtp(formik.values.mobile);
                                                                                                    },
                                                                                                    children: mobileOtpLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                                                                        animation: "border",
                                                                                                        size: "sm"
                                                                                                    }) : "Verify"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        mobileOtpError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (franchise_module_default()).otp_error,
                                                                                            children: mobileOtpError
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "col-md-5",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "mb-3",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (franchise_module_default()).inline_input_wrapper,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                            type: "email",
                                                                                            className: "form-control",
                                                                                            placeholder: "Email ID"
                                                                                        }, formik.getFieldProps("email"))),
                                                                                        emailVerified ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (franchise_module_default()).inline_badge,
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifiedBadge, {})
                                                                                        }) : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formik.values.email) && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                            type: "button",
                                                                                            className: (franchise_module_default()).inline_action_btn,
                                                                                            disabled: emailOtpLoading || emailResendTimer > 0,
                                                                                            onClick: function() {
                                                                                                return handleSendEmailOtp(formik.values.email);
                                                                                            },
                                                                                            children: emailOtpLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                                                                animation: "border",
                                                                                                size: "sm"
                                                                                            }) : emailResendTimer > 0 ? "Resend (".concat(emailResendTimer, "s)") : "Send OTP"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                formik.touched.email && formik.errors.email ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    className: "text-danger",
                                                                                    children: formik.errors.email
                                                                                }) : null,
                                                                                emailOtpUuid && !emailVerified && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: (franchise_module_default()).otp_field_group,
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                                    type: "text",
                                                                                                    className: "form-control ".concat((franchise_module_default()).otp_input),
                                                                                                    placeholder: "Enter OTP",
                                                                                                    maxLength: 6,
                                                                                                    value: emailOtp,
                                                                                                    onChange: function(e) {
                                                                                                        setEmailOtp(e.target.value.replace(/\D/g, ""));
                                                                                                        setEmailOtpError(null);
                                                                                                    }
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                                    type: "button",
                                                                                                    className: (franchise_module_default()).verify_btn,
                                                                                                    disabled: emailOtpLoading || emailOtp.length < 4,
                                                                                                    onClick: function() {
                                                                                                        return handleVerifyEmailOtp(formik.values.email);
                                                                                                    },
                                                                                                    children: emailOtpLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                                                                        animation: "border",
                                                                                                        size: "sm"
                                                                                                    }) : "Verify"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        emailOtpError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (franchise_module_default()).otp_error,
                                                                                            children: emailOtpError
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "col-md-4",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "mb-3",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                    type: "text",
                                                                                    className: "form-control",
                                                                                    placeholder: "Preferred Location"
                                                                                }, formik.getFieldProps("location"))),
                                                                                formik.touched.location && formik.errors.location ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    className: "text-danger",
                                                                                    children: formik.errors.location
                                                                                }) : null
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "col-md-4",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "mb-3",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                                    className: "form-select"
                                                                                }, formik.getFieldProps("state")), {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                            value: "",
                                                                                            disabled: true,
                                                                                            children: "Select state"
                                                                                        }),
                                                                                        !!state.length && state.map(function(v) {
                                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                                value: v.code,
                                                                                                children: v.name
                                                                                            }, v.code);
                                                                                        })
                                                                                    ]
                                                                                })),
                                                                                formik.touched.state && formik.errors.state ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    className: "text-danger",
                                                                                    children: formik.errors.state
                                                                                }) : null
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "col-md-4",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "mb-3",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                    type: "text",
                                                                                    className: "form-control",
                                                                                    placeholder: "Present Address"
                                                                                }, formik.getFieldProps("present_address"))),
                                                                                formik.touched.present_address && formik.errors.present_address ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    className: "text-danger",
                                                                                    children: formik.errors.present_address
                                                                                }) : null
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "col-md-6",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "mb-3",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                                        className: "form-select"
                                                                                    }, formik.getFieldProps("id_type")), {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                                value: "",
                                                                                                disabled: true,
                                                                                                children: "Select Id type"
                                                                                            }),
                                                                                            idType.map(function(v) {
                                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                                    value: v,
                                                                                                    children: v
                                                                                                }, v);
                                                                                            })
                                                                                        ]
                                                                                    })),
                                                                                    formik.touched.id_type && formik.errors.id_type ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                        className: "text-danger",
                                                                                        children: formik.errors.id_type
                                                                                    }) : null,
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            " "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "col-md-6",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "mb-3",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                    type: "text",
                                                                                    className: "form-control",
                                                                                    placeholder: "Id Number"
                                                                                }, formik.getFieldProps("id_number"))),
                                                                                formik.touched.id_number && formik.errors.id_number ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    className: "text-danger",
                                                                                    children: formik.errors.id_number
                                                                                }) : null
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-md-12",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                children: "Financial Details"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "row justify-content-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "col-md-6",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "mb-3",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                    type: "text",
                                                                                    className: "form-control",
                                                                                    placeholder: "Nature of Current Business"
                                                                                }, formik.getFieldProps("current_business"))),
                                                                                formik.touched.current_business && formik.errors.current_business ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    className: "text-danger",
                                                                                    children: formik.errors.current_business
                                                                                }) : null
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "col-md-6",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "mb-3",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                                                    type: "text",
                                                                                    className: "form-control",
                                                                                    placeholder: "Yearly Turnover (in crore)"
                                                                                }, formik.getFieldProps("turnover"))),
                                                                                formik.touched.turnover && formik.errors.turnover ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    className: "text-danger",
                                                                                    children: formik.errors.turnover
                                                                                }) : null
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "col-md-6 mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "d-block mb-1",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                    children: "Investment capacity"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "form-check form-check-inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                        className: "form-check-input",
                                                                                        type: "radio",
                                                                                        name: "capacity",
                                                                                        value: "5 cr. – 10 cr.",
                                                                                        checked: formik.values.capacity === "5 cr. – 10 cr.",
                                                                                        onChange: formik.handleChange,
                                                                                        id: "5-20"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                        className: "form-check-label",
                                                                                        htmlFor: "5-10",
                                                                                        children: "5 cr. – 10 cr."
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            " ",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "form-check form-check-inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                        className: "form-check-input",
                                                                                        type: "radio",
                                                                                        name: "capacity",
                                                                                        value: "10 cr. – 15 cr.",
                                                                                        checked: formik.values.capacity === "10 cr. – 15 cr.",
                                                                                        onChange: formik.handleChange,
                                                                                        id: "5-20"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                        className: "form-check-label",
                                                                                        htmlFor: "5-10",
                                                                                        children: "10 cr. – 15 cr."
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "form-check form-check-inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                        className: "form-check-input",
                                                                                        type: "radio",
                                                                                        name: "capacity",
                                                                                        value: "15 cr. - 20 cr.",
                                                                                        checked: formik.values.capacity === "15 cr. - 20 cr.",
                                                                                        onChange: formik.handleChange,
                                                                                        id: "5-20"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                        className: "form-check-label",
                                                                                        htmlFor: "5-10",
                                                                                        children: "15 cr. - 20 cr."
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "form-check form-check-inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                        className: "form-check-input",
                                                                                        type: "radio",
                                                                                        name: "capacity",
                                                                                        value: "20 cr. - 25 cr.",
                                                                                        checked: formik.values.capacity === "20 cr. - 25 cr.",
                                                                                        onChange: formik.handleChange,
                                                                                        id: "20-25"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                        className: "form-check-label",
                                                                                        htmlFor: "12-20",
                                                                                        children: "20 cr. - 25 cr."
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "form-check form-check-inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                        className: "form-check-input",
                                                                                        type: "radio",
                                                                                        name: "capacity",
                                                                                        value: "Above 25 cr.",
                                                                                        checked: formik.values.capacity === "Above 25 cr.",
                                                                                        onChange: formik.handleChange,
                                                                                        id: "above-25"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                        className: "form-check-label",
                                                                                        htmlFor: "above-25",
                                                                                        children: "Above 25 cr."
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "d-block",
                                                                                children: formik.touched.capacity && formik.errors.capacity ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    className: "text-danger",
                                                                                    children: formik.errors.capacity
                                                                                }) : null
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "col-md-6 mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "d-block mb-1",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                    children: "Mode of Investment"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "form-check form-check-inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                        className: "form-check-input",
                                                                                        type: "radio",
                                                                                        name: "mode",
                                                                                        value: "Own Equity",
                                                                                        checked: formik.values.mode === "Own Equity",
                                                                                        onChange: formik.handleChange,
                                                                                        id: "Own Equity"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                        className: "form-check-label",
                                                                                        htmlFor: "Own Equity",
                                                                                        children: "Own Equity"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "form-check form-check-inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                        className: "form-check-input",
                                                                                        type: "radio",
                                                                                        name: "mode",
                                                                                        value: "Bank Loan",
                                                                                        checked: formik.values.mode === "Bank Loan",
                                                                                        onChange: formik.handleChange,
                                                                                        id: "Bank Loan"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                        className: "form-check-label",
                                                                                        htmlFor: "Bank Loan",
                                                                                        children: "Bank Loan"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "form-check form-check-inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                        className: "form-check-input",
                                                                                        type: "radio",
                                                                                        name: "mode",
                                                                                        value: "Both",
                                                                                        checked: formik.values.mode === "Both",
                                                                                        onChange: formik.handleChange,
                                                                                        id: "Both"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                        className: "form-check-label",
                                                                                        htmlFor: "Both",
                                                                                        children: "Both"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "d-block",
                                                                                children: formik.touched.mode && formik.errors.mode ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    className: "text-danger",
                                                                                    children: formik.errors.mode
                                                                                }) : null
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "col-12 col-md-3 mt-2",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                            role: "button",
                                                                            "aria-label": "Submit Button",
                                                                            type: "submit",
                                                                            disabled: loading,
                                                                            style: {
                                                                                opacity: mobileVerified && emailVerified ? 1 : 0.6,
                                                                                cursor: mobileVerified && emailVerified ? "pointer" : "not-allowed"
                                                                            },
                                                                            children: [
                                                                                "SUBMIT",
                                                                                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                                                    style: {
                                                                                        fontSize: 6,
                                                                                        height: 20,
                                                                                        width: 20
                                                                                    },
                                                                                    animation: "border"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "container text-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "https://sencowebfiles.s3.ap-south-1.amazonaws.com/website/files/NKtVOOFi4KwaQdtarq7IMyx9NIzG68QeHZkU6l1j.png",
                                                    alt: "offer image",
                                                    width: 120,
                                                    height: 120
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "mb-4",
                                                    children: "Thank You!"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-center",
                                                    children: "The form was submitted successfully."
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (franchise_module_default()).five_star_container_desktop,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (franchise_module_default()).advantages_main,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (franchise_module_default()).advantages_main_header,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: adv_header,
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (franchise_module_default()).advantages_main_body,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "OVER 8 DECADES OF LEGACY"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: icon_adv/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Our Legacy of trust and integrity is built on its ethical business practices and focus on providing customers with the purest of exquisite jewelleries"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "2ND MOST TRUSTED , BRAND"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s2/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                "We have won several awards and accolades, including the 2nd most trusted brand in the jewellery category in India by TRA",
                                                                "'",
                                                                "S Brand Trust Report in 2020, 2021, 2022"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "OUR WORLD-CLASS KARIGARI ."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s3/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Our jewelleries are meticulously crafted by our team of karigars, using the traditional skills of world-famous Bengal artistry."
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "BIS HALLMARKED PUREST GOLD"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s4/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Rest assured, your Senco gold jewellery is of the highest standard & made of BIS hallmarked gold, so you can shop with confidence."
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "RIGHT PRICING"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s5/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "For over 8 decades, millions of connoisseurs trust our guarantee of right pricing on all products with beautiful craftsmanship."
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "FREE LIFETIME MAINTENANCE"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s6/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Enjoy the lifelong facility of free servicing for all your Senco jewellery, at any Senco showroom."
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "EXCHANGE & BUYBACK GUARANTEE"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s7/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Enjoy 0% deduction on old gold exchange & buyback facility for Senco jewellery, so you can keep changing your style & status quo!"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "CERTIFIED GENUINE DIAMONDS"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s8/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                "We offer only certified diamonds with buy back guarantee, so you can be sure you",
                                                                "'",
                                                                "re buying nothing but the best in the world."
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "EARN REWARDING POINTS"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s9/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Earn Loyalty Points with every purchase & enjoy the rewards of added benefits & cashback."
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "RESPONSIBLE JEWELLER"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s11/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "From sourcing materials to caring for our artisans & employees, we maintain the highest standards of ethics, environment-friendly practices & code of conduct"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "INSURED DIAMOND JEWELLERY"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s12/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "We offer free insurance on diamond jewellery, so you can dazzle stress-free!"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "OMNI-CHANNEL SERVICE"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s13/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Our omni-channel services allow customers to access our products through a variety of channels, including website, customer care, physical stores, video calls and MySenco mobile app."
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-6 d-none-mobile-view",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-flex align-items-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: "A world of benefits. crafted for you"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "EASY & REWARDING MONTHLY SAVING SCHEME"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s14/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Buy your dream jewellery in small monthly installments with our Swarna Yojana saving scheme, tailored for your convenience and earn more than bank interest."
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-6 d-none-desktop-view",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-flex align-items-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: "A world of benefits. crafted for you"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-12",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (franchise_module_default()).skv,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: skv/* default */.Z,
                                                    alt: ""
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (franchise_module_default()).five_star_container_mobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (franchise_module_default()).advantages_main,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (franchise_module_default()).advantages_main_header,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: adv_header,
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (franchise_module_default()).advantages_main_body,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center justify-content-space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "OVER 8 DECADES OF LEGACY"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: icon_adv/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Our Legacy of trust and integrity is built on its ethical business practices and focus on providing customers with the purest of exquisite jewelleries"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center justify-content-space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "2ND MOST TRUSTED , BRAND"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s2/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                "We have won several awards and accolades, including the 2nd most trusted brand in the jewellery category in India by TRA",
                                                                "'",
                                                                "S Brand Trust Report in 2020, 2021, 2022"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center justify-content-space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "OUR WORLD-CLASS KARIGARI ."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s3/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Our jewelleries are meticulously crafted by our team of karigars, using the traditional skills of world-famous Bengal artistry."
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center justify-content-space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "BIS HALLMARKED PUREST GOLD"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s4/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Rest assured, your Senco gold jewellery is of the highest standard & made of BIS hallmarked gold, so you can shop with confidence."
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center justify-content-space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "RIGHT PRICING"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s5/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "For over 8 decades, millions of connoisseurs trust our guarantee of right pricing on all products with beautiful craftsmanship."
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center justify-content-space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "FREE LIFETIME MAINTENANCE"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s6/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Enjoy the lifelong facility of free servicing for all your Senco jewellery, at any Senco showroom."
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center justify-content-space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "EXCHANGE & BUYBACK GUARANTEE"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s7/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Enjoy 0% deduction on old gold exchange & buyback facility for Senco jewellery, so you can keep changing your style & status quo!"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center justify-content-space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "CERTIFIED GENUINE DIAMONDS"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s8/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                "We offer only certified diamonds with buy back guarantee, so you can be sure you",
                                                                "'",
                                                                "re buying nothing but the best in the world."
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center justify-content-space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "EARN REWARDING POINTS"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s9/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Earn Loyalty Points with every purchase & enjoy the rewards of added benefits & cashback."
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center justify-content-space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "RESPONSIBLE JEWELLER"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s11/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "From sourcing materials to caring for our artisans & employees, we maintain the highest standards of ethics, environment-friendly practices & code of conduct"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center justify-content-space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "INSURED DIAMOND JEWELLERY"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s12/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "We offer free insurance on diamond jewellery, so you can dazzle stress-free!"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center justify-content-space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "OMNI-CHANNEL SERVICE"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s13/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Our omni-channel services allow customers to access our products through a variety of channels, including website, customer care, physical stores, video calls and MySenco mobile app."
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-6 d-none-mobile-view",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-flex align-items-center justify-content-space-between",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: "A world of benefits. crafted for you"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex align-items-center justify-content-space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "EASY & REWARDING MONTHLY SAVING SCHEME"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (franchise_module_default()).icon_adv,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: s14/* default */.Z,
                                                                    alt: ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Buy your dream jewellery in small monthly installments with our Swarna Yojana saving scheme, tailored for your convenience and earn more than bank interest."
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-6 d-none-desktop-view",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (franchise_module_default()).card_adv_pad,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-flex align-items-center justify-content-space-between",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: "A world of benefits. crafted for you"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-12",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (franchise_module_default()).skv,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: skv/* default */.Z,
                                                    alt: ""
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
Franchise.getLayout = function(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ var franchise_enquiry = (Franchise);


/***/ }),

/***/ 76703:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"franchise_banner":"franchise_franchise_banner__n_zCl","franchise_main":"franchise_franchise_main__OUy02","franchise_form":"franchise_franchise_form__s53PI","franchise_form_main":"franchise_franchise_form_main__7s4bK","sencofiveyear":"franchise_sencofiveyear__kb3fF","bgimage":"franchise_bgimage__bpOKd","sencofiveyear_main":"franchise_sencofiveyear_main__UVLmK","icon_box":"franchise_icon_box__La_bD","first":"franchise_first__Uw7WU","number":"franchise_number__T9MXQ","text1":"franchise_text1__Z9c7e","icon_box_m":"franchise_icon_box_m__LcVWo","advantages_main":"franchise_advantages_main__j_gbK","advantages_main_header":"franchise_advantages_main_header__LLZ_Y","advantages_main_body":"franchise_advantages_main_body__UUymj","skv":"franchise_skv__pu4_z","card_adv_pad":"franchise_card_adv_pad__qflvB","icon_adv":"franchise_icon_adv__DTXX8","five_star_container_desktop":"franchise_five_star_container_desktop__5ltI4","five_star_container_mobile":"franchise_five_star_container_mobile__Wqduo","text_head":"franchise_text_head__yAbVV","inline_input_wrapper":"franchise_inline_input_wrapper__g6DBw","inline_action_btn":"franchise_inline_action_btn__79ayQ","otp_field_group":"franchise_otp_field_group__tsNtG","otp_input":"franchise_otp_input__57gEb","verify_btn":"franchise_verify_btn__KbcOv","verified_badge":"franchise_verified_badge__G6WyD","otp_error":"franchise_otp_error__6OtY4","resend_link":"franchise_resend_link__HHF6G"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8523,4766,5675,9915,2640,3913,536,486,6646,1251,9774,2888,179], function() { return __webpack_exec__(79941); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);